import { AnyAction } from "redux";
import { DELETE_CARD_DESIGN, GET_ALL_CARD_DESIGNS } from "../actions/CardDesignActions";
import { GET_CUSTOMER_IDENTIFICATIONS } from "../actions/IdentificationActions";
import { CustomerIdentificationDto } from "../models/identification/CustomerIdentificationDto";
import { CardDesignDto } from "../models/carddesign/CardDesignDto";

export interface IIdentificationReducerState {
  cardDesigns: CardDesignDto[];
  identifications: CustomerIdentificationDto[];
}

export const identifications = (state: IIdentificationReducerState, action: AnyAction): IIdentificationReducerState => {
  switch (action.type) {
    case GET_ALL_CARD_DESIGNS:
      return {
        ...state,
        cardDesigns: action.payload,
      };
    case DELETE_CARD_DESIGN:
      const deletedCardDesign = action.payload as CardDesignDto;
      return {
        ...state,
        cardDesigns: state.cardDesigns.filter(
          (cardDesign) =>
            cardDesign.cardDesignNumber !== deletedCardDesign.cardDesignNumber
        ),
      };
    case GET_CUSTOMER_IDENTIFICATIONS:
      return {
        ...state,
        identifications: action.payload,
      };
    default:
      return state || { cardDesigns: [], identifications: [] };
  }
};
